import { resetDashboardState } from '@/store/slices/dashboard';
import { useAppDispatch } from './store';
import { resetAuthState } from '@/store/slices/auth';
import { resetOnboardingState } from '@/store/slices/onboarding';

const useResetStore = () => {
    const dispatch = useAppDispatch();

    return () => {
        dispatch(resetDashboardState());
        dispatch(resetAuthState());
        dispatch(resetOnboardingState());
    };
};

export default useResetStore;
